import { render } from "./widget-indicator-ok.vue?vue&type=template&id=e5ccf45e&ts=true"
import script from "./widget-indicator-ok.ts?vue&type=script&lang=ts"
export * from "./widget-indicator-ok.ts?vue&type=script&lang=ts"

import "./widget-indicator-ok.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__